import { rem, lighten } from "polished"

const current = {
  backgroundColor: ({ theme }) => lighten(0.5, theme.colors.red),
  borderColor: ({ theme }) => theme.colors.red,
  borderRadius: rem(8),
}

export default current
